import React, { useEffect, useRef, useState } from 'react';
import { Alert } from 'tea-component';

interface ErrorAlertType {
  visible: boolean;
  message: string | React.ReactNode;
  onClose: () => void;
}
export default function ErrorAlert(props: ErrorAlertType) {
  const {
    visible,
    message,
    onClose = () => console.log,
  } = props;
  const [alertVisible, setAlertVisible] = useState(visible);

  const timeRef = useRef<NodeJS.Timer>();

  useEffect(() => {
    if (timeRef.current) {
      clearTimeout(timeRef.current);
    }
    timeRef.current = setTimeout(() => {
      setAlertVisible(false);
      onClose();
    }, 5000);

    return () => {
      clearTimeout(timeRef.current);
    };
  }, [message]);

  const handleOnClose = () => {
    setAlertVisible(false);
    onClose();
  };

  return (
    <div className='login-alerterror'>
      <Alert
        type="error"
        visible={alertVisible}
        onClose={handleOnClose}>
        {message}
      </Alert>
    </div>
  );
}